import React from "react";
import {Typography} from "@material-ui/core";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
export default function UserConfirmation() {
    return (
        <>
            <section style={{padding:10, backgroundColor:"#eaeef3"}}>
                <div className="confirmationIcon">
                    <CheckCircleOutlineIcon style={{fontSize: 256}}/>
                </div>
                <Typography variant="h4" align="left" component="h4" gutterBottom   style={{paddingLeft:24, textAlign: 'center', fontWeight:600}}>
                    Confirmation
                </Typography>
                <Typography variant="h5" align="left" component="h5" gutterBottom style={{margin: 15}}>
                    Thank you for submitting your property quote request with the Florida Market Assistance Plan (FMAP).
                    Participating FMAP agents who are able to assist you, will contact you to gather any additional
                    information needed and provide you with information and quotes from private-market companies. A
                    registration confirmation email will be sent to you shortly. You can review your property quote,
                    request information, and/or update the coverage need by date for your request by selecting the link
                    provided in the email.
                </Typography>
            </section>
        </>
    );
}
